"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClient = exports.getMenuElements = void 0;
const client_1 = require("@apollo/client");
const error_1 = require("@apollo/client/link/error");
const isomorphic_unfetch_1 = __importDefault(require("isomorphic-unfetch"));
exports.getMenuElements = (0, client_1.gql) `
  query getMenu {
    getMenu {
      menu {
        name
        link
        subMenu {
          name
          link
        }
      }
      nybyggmenu {
        name
        link
        subMenu {
          name
          link
        }
      }
      submenu {
        name
        link
        subMenu {
          name
          link
        }
      }
    }
  }
`;
const errorlink = (0, error_1.onError)(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
        graphQLErrors.map(({ message, locations, path }) => console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`));
    if (networkError)
        console.log(`[Network error]: ${networkError}`);
});
const getClient = () => {
    const link = new client_1.HttpLink({
        uri: 'https://pmgraph.reeltime.no/graphql',
        fetch: isomorphic_unfetch_1.default,
    });
    const ac = new client_1.ApolloClient({
        cache: new client_1.InMemoryCache(),
        ssrMode: true,
        link: (0, client_1.from)([errorlink, link]),
    });
    return ac;
};
exports.getClient = getClient;
//# sourceMappingURL=query.js.map